export default "__VITE_ASSET__7f935357__"